import React from 'react';
import { Eyebrow } from './Eyebrow';
import { SCENES } from '../data/landing';
export function ScenesSection() {
  return <section className="bg-carbon-3 py-14 md:py-20" aria-labelledby="scenes-title" data-id="element-155" data-mp="3qu0sqc31mor6">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-156" data-mp="3m0oemvvzq0co">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-157" data-mp="3h365b4e29j45">
          <Eyebrow tone="dark" data-id="element-158" data-mp="3h2mmzmki0spl">¿Te suena familiar?</Eyebrow>
          <h2 id="scenes-title" className="mt-4 text-[26px] leading-[1.15] text-ink-light sm:text-[34px] lg:text-[38px]" data-id="element-159" data-mp="3d1kwpv8k7qzr">
            ¿Te reconoces en alguna de estas situaciones?
          </h2>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-160" data-mp="333dfdbacz6x8">
          {SCENES.map((scene, index) => <li key={scene.title} className="rounded-[14px] bg-carbon-card p-5 md:p-6" data-id="element-161" data-mp="2y64yde0y58xk" data-mpi={index}>
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gold/20 text-[10px] font-bold text-gold-light" data-id="element-162" data-mp="wcx859jsp6ww">
                {index + 1}
              </span>
              <h3 className="mt-3 text-[13px] font-bold text-ink-light md:text-[14px]" data-id="element-163" data-mp="18v7ix4o7jzz2">
                {scene.title}
              </h3>
              <p className="mt-2 text-[12px] font-medium leading-relaxed text-ink-light/60 md:text-[13px]" data-id="element-164" data-mp="yvgpl6bdvr0k">
                {scene.text}
              </p>
            </li>)}
        </ul>

        <p className="mt-10 text-center text-[16px] font-extrabold tracking-[-0.02em] text-ink-light md:text-[19px]" data-id="element-165" data-mp="1rj2q25pbefj7">
          La conexión puede ser el comienzo. No tiene por qué ser el final.{' '}
          <span className="text-gold" aria-hidden="true" data-id="element-166" data-mp="1hub4cfaukrgq">
            →
          </span>
        </p>
      </div>
    </section>;
}